export default "__VITE_ASSET__CBGpX098__"